import * as XLSX from "xlsx";

export function parseImportedCampaigns(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];

              const rows = XLSX.utils.sheet_to_json(sheet, { range: 1, defval: "" });

        const changes = [];
        const errors = [];

        rows.forEach((row) => {
          const id = row["ID"];
          const campaignName = row["Campaña"] || "";
          const rawBudget = row["Presupuesto diario"];
          const rawRoas = row["ROAS Objetivo"];

          if (!id && id !== 0 && !campaignName) return;

          // Validar que los campos editables sean numéricos si tienen valor
          if (
            rawBudget !== "" &&
            rawBudget != null &&
            isNaN(Number(rawBudget))
          ) {
            errors.push({
              campaignName,
              field: "Presupuesto diario",
              value: rawBudget,
            });
          }
          if (rawRoas !== "" && rawRoas != null && isNaN(Number(rawRoas))) {
            errors.push({
              campaignName,
              field: "ROAS Objetivo",
              value: rawRoas,
            });
          }

          changes.push({
            id: id != null && id !== "" ? String(id) : null,
            campaignName,
            dailyBudget:
              rawBudget !== "" && rawBudget != null ? Number(rawBudget) : null,
            targetRoas:
              rawRoas !== "" && rawRoas != null ? Number(rawRoas) : null,
          });
        });

        resolve({ changes, errors });
      } catch (err) {
        reject(err);
      }
    };

    reader.onerror = () => reject(new Error("Error al leer el archivo."));
    reader.readAsArrayBuffer(file);
  });
}
